import React, { useState, useEffect } from "react";
import { fetchDataGet } from "../../controler/comunicacao";
import CardChart from "../../components/Card/Card.jsx";
import ChartBarIncidence from "../../components/Charts/ChartBarIncidence.jsx";

import "../Dashboard.css";

function DashBoard() {
  const [incidencia, setIncidencia] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    Promise.all([
      fetchDataGet("/api/grafico1"),
    ])
      .then(
        ([
          dados1,
        ]) => {
          setIncidencia(dados1);
        }
      )
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <section className="container-fluid dashboard px-0">
      <div className="row gx-3 gy-3 mb-3">
        {/* CARD INCIDENCIA 1*/}
        <CardChart
          title="Coeficiente de incidência e numero de casos por ano de diagnóstico"
          tooltipText="Utilize o gráfico para visualizar o coeficiente de incidência de casos ao longo do tempo."
          modalId="Modal25"
          loading={loading}
          cols="col-12"
        >
          <ChartBarIncidence data={incidencia} />
        </CardChart>
      </div >
    </section>
  );
}

export default DashBoard;
